var target = document.querySelector("#offer-tw");
if (target) {
	var options = {
		rootMargin: "0px",
		threshold: 0.01,
	};
	var callback = function (entries, observer) {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				window.addEventListener("scroll", scrollCars, { passive: true });
			} else {
				window.removeEventListener("scroll", scrollCars, { passive: true });
			}
		});
	};
	var observer = new IntersectionObserver(callback, options);

	observer.observe(target);

	function scrollCars() {
		const offer = document.querySelector("#observer-offer");
		const cars = document.querySelector("#observer-cars");

		const carsRect = cars.getBoundingClientRect();
		const offerRect = offer.getBoundingClientRect();

		const ford = document.getElementById("ford");
		const bmw = document.getElementById("bmw");
		const y = ((carsRect.top - offerRect.bottom) * 50) / carsRect.height;

		if (Math.round(carsRect.top) < offerRect.bottom) {
			ford.style.transform = `translateX(${y}%)`;
			bmw.style.transform = `translateX(${-y}%)`;
		}
	}
	scrollCars();
}
